import { PureFunctional, React } from '../../react';
import '../../types';
import Window from '../../window/component';

// Notes
import { NotesEditModal as NoteEditModal } from '../notes/noteEditModal';
import NotesInspectModal from '../notes/noteInspectModal';
import NoteBatchDeleteModal from '../notes/batchDeleteModal';
import NoteDeleteModal from '../notes/noteDeleteModal';

// Bookmarks
import BookmarksBatchDeleteModal from '../bookmarks/batchDeleteModal';
import BookmarkEditModal from '../bookmarks/editModal';

// Categories
import CategoryBatchDeleteModal from '../categories/batchDeleteModal';
import CategoryDeleteModal from '../categories/deleteModal';
import CategoryEditModal from '../categories/categoryEditModal';

// UserGroups
import UsergroupsEditModal from '../../usergroup/editModal';
import UsergroupInspectModal from '../../usergroup/inspectModal';
import UsergroupDeleteModal from '../../usergroup/deleteModal';
import FactionEditModal from '../../usergroup/editFactionModal';
import RoleEditModal from '../../usergroup/editRoleModal';

// Question
import QuestionAddresseeEditModal from '../../questionaddressee/editModal';
import { QuestionEditModal } from '../question/questionEditModal';
import QuestionInspectModal from '../question/questionInspectModal';
import QuestionChangeStatusModal from '../question/batchChangeStatusModal';

/* tslint:disable */
declare interface WebpackRequire extends NodeRequire {
    ensure(a: any[], b: (r: any) => any): any;
}
declare var require: WebpackRequire;
declare global {
    interface Console {
        timeStamp(name: string): void;
    }
}
/* tslint:enable */

export default PureFunctional(`NoteUI`)(
    () => (
        <div>
            <Window />

            <NoteEditModal />
            <QuestionEditModal />  
            <NotesInspectModal />
            <QuestionInspectModal />
            <QuestionChangeStatusModal />
            <NoteDeleteModal />
            <NoteBatchDeleteModal />

            <BookmarkEditModal />
            <BookmarksBatchDeleteModal />

            <CategoryEditModal />
            <CategoryDeleteModal />
            <CategoryBatchDeleteModal />

            {/* <StatusDialog /> */}
            <CategoryDeleteModal />
            <UsergroupsEditModal />
            <FactionEditModal />  
            <RoleEditModal/>          
            <UsergroupInspectModal />
            <UsergroupDeleteModal />

            <QuestionAddresseeEditModal />       

            {/* {process.env.NODE_STAGE === 'development' ? <Debug /> : null } */}
        </div>
    ));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/ui/index.tsx